import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-fill text-accent-500 text-2xl"></i>
            </div>
            <span className="font-heading text-xl text-foreground-950">免费电影</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-accent-500/15 text-accent-500'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/50'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').slice(0, 5).map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-accent-500/15 text-accent-500'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/all"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'bg-accent-500/15 text-accent-500'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/50'
              }`}
            >
              更多分类
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-accent-500'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              关于我们
            </Link>
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电影..."
                className="w-48 px-4 py-1.5 rounded-full bg-background-200/70 border border-background-300/50 text-sm text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500/50 focus:ring-1 focus:ring-accent-500/30 transition-all"
              />
              <div className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-foreground-400 text-sm"></i>
              </div>
            </div>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:text-foreground-900 hover:bg-background-200/50 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/60">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              首页
            </Link>
            {categories.map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-200/50 transition-colors cursor-pointer"
              >
                <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
                  <i className={`${cat.icon} text-foreground-400 text-sm`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}